import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsService } from '../../../../../shared/API-Service/services/projects.service';
import Swal from 'sweetalert2';
import {Projects} from "../../../../../shared/Models/Projects";
import { environment } from 'src/environments/environment.prod';
import { KeywordsService } from 'src/app/shared/API-Service/services/keywords.service';

@Component({
  selector: 'app-insert-project',
  templateUrl: './insert-project.component.html',
  styleUrls: ['./insert-project.component.css']
})
export class InsertProjectComponent implements OnInit {
  id: string;
  update: boolean;
  insertForm: FormGroup;
  Projects = new Projects();
  imageLogo:any
  Image: any;
  Project: any;
  CreatProjectForm: any = new FormData();
  keyword:object [] = [];
  selectedItems: any;
  dropdownSettings: any = {};
DisableBtn:boolean
  constructor(private _KeywordsService:KeywordsService,private ProjectsService:ProjectsService,private _formBuilder: FormBuilder,private router: Router,private route: ActivatedRoute) {
    this.imageLogo="../../../../../assets/images/upload.png"
   }
  
  
  ngOnInit(): void {
    this.getkeywords();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'titleAr',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
     
  };
    if (this.route.snapshot.paramMap.get("id")) {
      this.id =this.route.snapshot.paramMap.get("id")
      this.ProjectsService.GetProjectsByid(this.id).subscribe(async (res:any)=>{
      this.Project=  await res.data;
      this.selectedItems=this.Project.keywordsNames;
      this.imageLogo=environment.ServerImages_URL+'/'+this.Project.image
        this.initForm(this.Project);
        
      })
      this.update = true;
    } else {
      this.initForm()
      this.update = false;
    }
  }

  initForm(Projects?: Projects) {
    this.insertForm = this._formBuilder.group({
      title: [Projects?.title || ''],
      titleAr: [Projects?.titleAr || '', Validators.required],
      description: [Projects?.description || ''],
      descriptionAr: [Projects?.descriptionAr || '', Validators.required],
      videoLink: [Projects?.videoLink || ''],
      facebookLink: [Projects?.facebookLink || ''],
      instagramLink: [Projects?.instagramLink || ''],
      youtubeLink: [Projects?.youtubeLink || ''],
      tiktokLink: [Projects?.tiktokLink || ''],
      image: [Projects?.image || ''],
      keywords:[this.selectedItems||'']
    });
  }
  getkeywords(){
    this._KeywordsService.Getkeywords().subscribe((res) => {
      this.keyword = res.data; 
    },(err) => {
    },() => {
    })
   }
  get fc() {
    return this.insertForm.controls;
  }

  
  Submit(){
    this.DisableBtn=true;
    if (this.insertForm.status == "VALID") {
  
      if (this.update == true) {
        this.UpdateProject();
      } else {
        this.InsertProject();
      }
    }
     else {
      this.DisableBtn=false
      this.insertForm.markAllAsTouched();
    }
  

  }
  UpdateProject(){
    this.CreatProjectForm.set('ProjectImage', this.Image)
    this.CreatProjectForm.set('Title',this.insertForm.get('title').value)
    this.CreatProjectForm.set('TitleAr',this.insertForm.get('titleAr').value)
    this.CreatProjectForm.set('Description',this.insertForm.get('description').value)
    this.CreatProjectForm.set('DescriptionAr',this.insertForm.get('descriptionAr').value)
    this.CreatProjectForm.set('VideoLink',this.insertForm.get('videoLink').value)
    this.CreatProjectForm.set('FacebookLink',this.insertForm.get('facebookLink').value)
    this.CreatProjectForm.set('InstagramLink',this.insertForm.get('instagramLink').value)
    this.CreatProjectForm.set('YoutubeLink',this.insertForm.get('youtubeLink').value)
    this.CreatProjectForm.set('TiktokLink',this.insertForm.get('tiktokLink').value)
   if(this.selectedItems){
    this.selectedItems.forEach(element => {
      this.CreatProjectForm.append("Keywords", element.id);   
      });
   }
    
    this.CreatProjectForm.set('id',this.id)
    this.ProjectsService.UpdateProject(this.CreatProjectForm).subscribe(
      (response) => {
      Swal.fire({
      icon: "success",
      title: "تم التعديل بنجاح",
      showConfirmButton: false,
      timer: 1500,
      });
      this.DisableBtn=false;
      this.router.navigateByUrl("content/admin/ViewProjects");
    },
      (err) => {
        this.DisableBtn=false;

        Swal.fire({
          icon: "error",
          title:err.error.message
          });
      }
  
      );
  }
  InsertProject(){
    if(this.Image){
      this.CreatProjectForm.set('ProjectImage', this.Image)
      this.CreatProjectForm.set('Title',this.insertForm.get('title').value)
      this.CreatProjectForm.set('TitleAr',this.insertForm.get('titleAr').value)
      this.CreatProjectForm.set('Description',this.insertForm.get('description').value)
      this.CreatProjectForm.set('DescriptionAr',this.insertForm.get('descriptionAr').value)
      this.CreatProjectForm.set('Description',this.insertForm.get('description').value)
      this.CreatProjectForm.set('VideoLink',this.insertForm.get('videoLink').value)
      this.CreatProjectForm.set('FacebookLink',this.insertForm.get('facebookLink').value)
      this.CreatProjectForm.set('InstagramLink',this.insertForm.get('instagramLink').value)
      this.CreatProjectForm.set('YoutubeLink',this.insertForm.get('youtubeLink').value)
      this.CreatProjectForm.set('TiktokLink',this.insertForm.get('tiktokLink').value)
      if(this.selectedItems){
        this.selectedItems.forEach(element => {
          this.CreatProjectForm.append("Keywords", element.id);   
          });
       }
    this.ProjectsService.CreateProject(this.CreatProjectForm).subscribe(
      (response) => {
      Swal.fire({
      icon: "success",
      title: "تم الحفظ بنجاح",
      showConfirmButton: false,
      timer: 1500,
      });
      this.DisableBtn=false;

      this.router.navigateByUrl("content/admin/ViewProjects");

    },
      (err) => {
        this.DisableBtn=false;

        Swal.fire({
          icon: "error",
          title:err.error.message
          });
      }
            );
    }
    else{
      this.DisableBtn=false;

      Swal.fire({
        icon: "error",
        title:"يرجى اختيار الصورة"
        });
    }
 
  }
  OpenImage(imagesView){
    Swal.fire({
      imageUrl: imagesView,
      imageHeight: 400,
      imageAlt: 'A tall image',
      confirmButtonText:"الغاء"
    })
  }
  getLogoUrl(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.Image = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageLogo = reader.result as string;
        // this.logoForm?.set("image", this.Image);
      };
    }
  }
}
